import axios from 'axios';
import { default as _Vue } from 'vue';
import { getProcessEnv } from '@/lib/build';

export enum EVersion {
  V1 = 'v1',
}

/**
 * Helper
 */
export default class API {
  private readonly Vue: typeof _Vue;
  private readonly url: string;

  constructor(Vue: typeof _Vue) {
    this.Vue = Vue;
    this.url = getProcessEnv('PAYMENTS');
  }

  /**
   * GET
   * @param version
   * @param endpoint
   */
  public get(version: EVersion, endpoint: string) {
    return axios.get(`${this.url}/${version}/${endpoint}`, {
      headers: {
        authorization: `Bearer ${this.Vue.prototype.$pdc.cognito.accessToken}`,
      },
    });
  }

  /**
   * POST
   * @param version
   * @param endpoint
   * @param payload
   */
  public post(version: EVersion, endpoint: string, payload: any = null) {
    return axios.post(`${this.url}/${version}/${endpoint}`, payload, {
      headers: {
        authorization: `Bearer ${this.Vue.prototype.$pdc.cognito.accessToken}`,
      },
    });
  }
}
